import * as actionTypes from 'constants/ActionTypes';

export function getCargoGazetters(opts) {
    return {
        type: actionTypes.GET_CARGO_GAZETTERS.REQUEST,
        opts,
    };
}

export function deleteCargoGazetter(item) {
    return {
        type: actionTypes.DELETE_CARGO_GAZETTER.REQUEST,
        item,
    };
}



// WEBPACK FOOTER //
// ./app/actions/cargoes/gazetters.js